import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import VideoCard from '@/components/feature/VideoCard';
import SectionHeader from '@/components/feature/SectionHeader';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import { videos } from '@/mocks/videos';

export default function Home() {
  const latestVideos = useMemo(
    () => [...videos].sort((a, b) => b.addedAt.localeCompare(a.addedAt)).slice(0, 8),
    []
  );

  const featuredVideos = useMemo(() => {
    const featured = videos.filter((v) => v.featured);
    const rest = videos.filter((v) => !v.featured).sort((a, b) => b.rating - a.rating);
    return [...featured, ...rest].slice(0, 8);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1">
        <div className="max-w-[1440px] mx-auto px-4 md:px-8">
          <div className="pt-6">
            <HeroCarousel />
          </div>

          <CategoryEntries />

          <section className="mt-12">
            <SectionHeader
              title="新片抢先看"
              subtitle="按上架时间排序，第一时间发现最新内容"
              moreTo="/category/movie"
              moreLabel="更多新片"
            />
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {latestVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </section>

          <section className="mt-12">
            <SectionHeader
              title="精选推荐"
              subtitle="结合热度与口碑，为你精选值得一看的优质内容"
              moreTo="/search"
              moreLabel="去搜索"
            />
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {featuredVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </section>

          <section className="mt-12 mb-4">
            <div className="rounded-lg bg-foreground-950 text-background-100 p-6 md:p-10 flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-1">
                <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-background-50">
                  关于糖心视频
                </h2>
                <p className="mt-4 text-sm md:text-base text-background-200/85 leading-relaxed max-w-2xl">
                  糖心视频是一个聚合电影、电视剧、综艺及短视频等多类别高清视频内容的发现平台。
                  我们希望通过清晰的内容层级、多维筛选与便捷搜索，帮助每一位观众轻松找到心仪的作品。
                  本站内容均为演示示例，真实播放接口暂未接入。
                </p>
                <div className="flex items-center gap-3 mt-6">
                  <Link
                    to="/about"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    了解我们
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                  <Link
                    to="/search"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50/15 text-background-50 text-sm font-semibold hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-search-line"></i>
                    搜索内容
                  </Link>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-6 md:gap-10 w-full lg:w-auto">
                <div className="text-center">
                  <p className="font-heading text-2xl md:text-3xl font-extrabold text-primary-400">4</p>
                  <p className="text-xs text-background-200/70 mt-1">内容分类</p>
                </div>
                <div className="text-center">
                  <p className="font-heading text-2xl md:text-3xl font-extrabold text-accent-400">24+</p>
                  <p className="text-xs text-background-200/70 mt-1">精选示例</p>
                </div>
                <div className="text-center">
                  <p className="font-heading text-2xl md:text-3xl font-extrabold text-background-50">HD</p>
                  <p className="text-xs text-background-200/70 mt-1">高清画质</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}